import { ResultH1, ResultH25, ResultH28, SubComponent, UVPictureCanvas, UVPictureSkeleton, UVTextContainer, WhiteButton } from '../../styles/newResultsStyle';
import { CliniqueState, ResultStep } from '../../type';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConcernImage from '../ConcernImage';

interface UVDamagesI {
	resultStep: ResultStep;
}

export const UVDamagesTab = (props: UVDamagesI) => {
	const { t } = useTranslation();
	const { demkyInvisibleDamage } = useSelector((state: CliniqueState) => state.session);
	const hasDemkyInvisibleDamage = Boolean(demkyInvisibleDamage?.detectedPixels?.length);

	return (
		<SubComponent style={{ backgroundColor: '#FAFAFA', justifyContent: 'initial', padding: '16px 0px' }} $height={'initial'}>
			<div style={{ position: 'relative', maxHeight: '700px', overflow: 'hidden' }}>
				{hasDemkyInvisibleDamage ? <ConcernImage as={UVPictureCanvas} image='' concern='invisible_damages' /> : <UVPictureSkeleton />}
			</div>

			<UVTextContainer>
				<div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '4px' }}>
					<ResultH1 style={{ textAlign: 'start', font: "normal normal 700 24px/28px 'Clinique Helvetica Neue'" }}>{t('your-uv-damage')}</ResultH1>

					<ResultH25>{t('uvdamage-our-tech')}</ResultH25>
				</div>

				<div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '16px', alignItems: 'start' }}>
					<ResultH25 style={{ color: '#666666' }}>{t('uvdamage-to-help')}</ResultH25>

					<WhiteButton>
						<ResultH28>{t('uvdamage-seeSPF')}</ResultH28>
					</WhiteButton>
				</div>
			</UVTextContainer>
		</SubComponent>
	);
};
